import { render, staticRenderFns } from "./dot-chart.vue?vue&type=template&id=4b5c35d9&scoped=true"
import script from "./dot-chart.vue?vue&type=script&lang=js"
export * from "./dot-chart.vue?vue&type=script&lang=js"
import style0 from "./dot-chart.vue?vue&type=style&index=0&id=4b5c35d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5c35d9",
  null
  
)

export default component.exports